import { UserOnboardingStep } from '../types/models/user.js';

export const OnboardingSteps = UserOnboardingStep;

export const OnboardingStepsLabels: Record<UserOnboardingStep, string> = {
  [UserOnboardingStep.NOT_STARTED]: 'Non démarré',
  [UserOnboardingStep.GCU]: "Conditions Générales d'Utilisation",
  [UserOnboardingStep.PASSWORD]: 'Création du mot de passe',
  [UserOnboardingStep.PERSONAL_INFORMATION]: 'Informations personnelles',
  [UserOnboardingStep.ZONE_OF_SEARCH]: 'Zone de recherche',
  [UserOnboardingStep.WISHED_JOBS]: 'Métier(s) recherché(s)',
  [UserOnboardingStep.CAREER]: 'Parcours professionnel',
  [UserOnboardingStep.SKILLS]: 'Compétences',
  [UserOnboardingStep.COMPLETED]: 'Terminé',
};

export enum OnboardingBucket {
  NOT_STARTED = 'not_started',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
}

export const OnboardingBucketLabels: Record<OnboardingBucket, string> = {
  [OnboardingBucket.NOT_STARTED]: 'Non démarré',
  [OnboardingBucket.IN_PROGRESS]: 'En cours',
  [OnboardingBucket.COMPLETED]: 'Terminé',
};

export function getOnboardingBucket(step: UserOnboardingStep): OnboardingBucket {
  if (step === UserOnboardingStep.NOT_STARTED) return OnboardingBucket.NOT_STARTED;
  if (step === UserOnboardingStep.COMPLETED) return OnboardingBucket.COMPLETED;
  return OnboardingBucket.IN_PROGRESS;
}

/**
 * Tone names used by Badge / status indicators on the client. Kept as a string
 * union so this constants file stays free of client-only types.
 */
export type OnboardingBucketColor = 'neutral' | 'accent' | 'positive';

export const OnboardingBucketColors: Record<OnboardingBucket, OnboardingBucketColor> = {
  [OnboardingBucket.NOT_STARTED]: 'neutral',
  [OnboardingBucket.IN_PROGRESS]: 'accent',
  [OnboardingBucket.COMPLETED]: 'positive',
};

export function getOnboardingBucketLabel(step: UserOnboardingStep | null | undefined): string {
  if (step == null) return '';
  return OnboardingBucketLabels[getOnboardingBucket(step)];
}

export function getOnboardingBucketColor(
  step: UserOnboardingStep | null | undefined,
): OnboardingBucketColor {
  if (step == null) return 'neutral';
  return OnboardingBucketColors[getOnboardingBucket(step)];
}
